import React, { useState } from 'react'
import { Modal, message, Upload, Button } from 'antd'
import { saveFacilityBanner } from '../../api'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .title {
    font-size: 36px;
    font-weight: 600;
  }
  .upload-avatar {
    margin-bottom: 24px;
    .preview-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 203px;
      img {
        height: 100%;
      }
    }
  }

  .facility-logo-placeholder {
    background-color: #eceef4;
    font-size: 14px;
    letter-spacing: 0.3px;
    font-weight: 600;
    height: 203px;
    width: 436px;
    color: #264382;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 11px;
    cursor: pointer;

    & > img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .has-banner {
    background-color: transparent;
  }
`

const ARDeckBannerModal = (props) => {
  const { facility, onCancel, saveSync, viewOnly = false } = props

  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState(null)
  const [imageUrl, setImageUrl] = useState('')

  const submit = async () => {
    if (file) {
      let result
      setLoading(true)
      try {
        result = await saveFacilityBanner(file, facility.id)
        saveSync(result.banner)
        setLoading(false)
        message.success('Upload banner succeed')
      } catch (err) {
        console.error(err)
        setLoading(false)
      }
    } else {
      onCancel()
    }
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  const customRequest = (request) => {
    const { file } = request
    getBase64(file, (imageUrl) => {
      setImageUrl(imageUrl)
      setFile(file)
    })
  }

  const avatar =
    imageUrl || (facility && facility.banner && facility.banner.oss_url)

  return (
    <StyledModal
      open={true}
      onCancel={onCancel}
      width={484}
      footer={
        avatar &&
        !viewOnly && (
          <>
            <Button onClick={onCancel} ghost type="primary">
              CANCEL
            </Button>
            <Button onClick={submit} type="primary" loading={loading}>
              SAVE
            </Button>
          </>
        )
      }
    >
      <h1 className="title">{viewOnly ? 'Banner' : 'Upload banner'} </h1>
      <div className="upload-avatar">
        {viewOnly ? (
          avatar && (
            <div className="preview-wrapper">
              <img
                src={avatar}
                alt="banner"
                style={{
                  objectFit: 'scale-down'
                }}
              />
            </div>
          )
        ) : (
          <Upload
            name="avatar"
            customRequest={customRequest}
            showUploadList={false}
          >
            <div
              className={`facility-logo-placeholder ${
                avatar ? 'has-banner' : ''
              }`}
            >
              {avatar ? (
                <img
                  src={avatar}
                  alt="banner"
                  style={{
                    objectFit: 'scale-down'
                  }}
                />
              ) : (
                <> + Upload Banner</>
              )}
            </div>
          </Upload>
        )}
      </div>
    </StyledModal>
  )
}

export default ARDeckBannerModal
